<template>
    <ion-row>
        <template v-for="(file, index) in $store.getters['dokbox/images']">
            <ion-col
                size="12"
                :key="'date-' + index"
                v-if="getMonthLabel(index) !== ''"
            >
                <div class="c-chip">
                    {{ getMonthLabel(index) }}
                </div>
            </ion-col>
            <ion-col
                size="4"
                size-md="3"
                :key="'image-' + index"
                @click="$store.commit('setGalleryIndex', index)"
                class="ion-text-center"
            >
                <div
                    class="c-gallery__image"
                    :style="
                        'background-image: url(' +
                        $store.state.dokbox.base64Images[file.fileHash] +
                        ')'
                    "
                >
                    <ion-spinner
                        v-if="!$store.state.dokbox.base64Images[file.fileHash]"
                        class="ion-margin-top c-gallery__spinner"
                    ></ion-spinner>
                </div>
            </ion-col>
        </template>
    </ion-row>
</template>

<script>
import { BASEURL } from "@/utils/globals";
import { DateFormatter } from "@/utils/date";

export default {
    props: {
        token: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            baseurl: BASEURL,
            api_static: process.env.VUE_APP_API_STATIC,
            // dayNames: ["Son", "Mon", "Die", "Mit", "Don", "Fre", "Sam"]
        };
    },
    mounted() {},
    methods: {
        getMonthLabel(index) {
            let result = "";
            if (
                this.$store.state.dokbox.files[index] &&
                (index === 0 ||
                    this.$store.state.dokbox.files[
                        index - 1
                    ].fileDate.substring(0, 6) !==
                        this.$store.state.dokbox.files[
                            index
                        ].fileDate.substring(0, 6))
            ) {
                result = DateFormatter.formatDate(
                    new Date(this.$store.state.dokbox.files[index].fileDate),
                    "MMMM YYYY"
                );
            }
            return result;
        },
        // getDayName(date) {
        //   // const tempdate = new Date(date);
        //   // let result = this.dayNames[tempdate.getDay()];
        //   // return result;
        //   return DateFormatter.formatDate(new Date(date), "ddd");
        // },
        // getDay(date) {
        //   // let result = "";
        //   // let tempdate = new Date(date).getDay();
        //   // result = ("0" + tempdate).slice(-2);
        //   // return result;
        //   return DateFormatter.formatDate(new Date(date), "DD");
        // }
    },
};
</script>

<style lang="scss" scoped>
.c-gallery {
    &__image {
        // padding: 0;
        background-size: cover;
        background-position: center;
        // height: 150px;
        border-radius: var(--gangl-border-radius);
        border: solid 1px var(--ion-color-medium);
        cursor: pointer;
        position: relative;
        &:after {
            content: "";
            display: block;
            padding-bottom: 100%;
        }
    }
    &__spinner {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        margin: auto;
    }
    // &__description {
    //   font-weight: bold;
    // }
    &__month {
        margin-bottom: var(--gangl-padding-xlarge);
        background: var(--ion-color-medium);
        position: relative;
        padding: var(--gangl-padding-small) var(--gangl-padding-medium);
        display: inline-block;
        border-radius: 200px;
        font-weight: bold;
    }
}
</style>
